'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelTextStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  hasTooltip: _propTypes2.default.bool
};
var defaultProps = {
  hasTooltip: void 0
};

var spacing = function spacing(_ref) {
  var themeFromProvider = _ref.theme,
      hasTooltip = _ref.hasTooltip;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var labelTooltipSpacing = theme.reactackle.components.checkbox.label.labelTooltipSpacing;
  return hasTooltip ? ' padding-right: ' + (0, _reactackleCore.getValueString)(labelTooltipSpacing) + ';' : '';
};

var LabelTextStyled = exports.LabelTextStyled = _styledComponents2.default.span.withConfig({
  displayName: 'LabelTextStyled'
})(['', ';', ';'],
/* Prettier workarount until issue is not fixed: https://github.com/prettier/prettier/issues/2291 */
'', spacing);

LabelTextStyled.displayName = 'LabelTextStyled';
LabelTextStyled.propTypes = propTypes;
LabelTextStyled.defaultProps = defaultProps;